import { HealthSystemDomainAnimalsResultAnimalsFarmSearchRequest } from '../api/HealthSystemApi';

export interface PageableResult<T> {
  data: T[];
  total: number;
  size: number;
  page: number;
}

export interface CreateEntityBatchResult {
  success: string[];
  errors: CreateEntityError[];
}

export interface CreateEntityError {
  id: string;
  codes: string[];
}

export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

export const AcceptedDaysOfWeekOrdered = [
  DayOfWeek.Monday,
  DayOfWeek.Tuesday,
  DayOfWeek.Wednesday,
  DayOfWeek.Thursday,
  DayOfWeek.Friday,
  DayOfWeek.Saturday,
  DayOfWeek.Sunday
];

export const DayOfWeekTranslations: Record<DayOfWeek, string> = {
  [DayOfWeek.Monday]: 'f-com-monday',
  [DayOfWeek.Tuesday]: 'f-com-tuesday',
  [DayOfWeek.Wednesday]: 'f-com-wednesday',
  [DayOfWeek.Thursday]: 'f-com-thursday',
  [DayOfWeek.Friday]: 'f-com-friday',
  [DayOfWeek.Saturday]: 'f-com-saturday',
  [DayOfWeek.Sunday]: 'f-com-sunday'
};

export enum TaskListItemType {
  SickAnimals = 10,
  Injections = 20,
  Other = 30
}

export const TaskListItemTypeTranslations: Record<TaskListItemType, string> = {
  [TaskListItemType.SickAnimals]: 'f-tasks-item-type-sick-animals',
  [TaskListItemType.Injections]: 'f-tasks-item-type-injections',
  [TaskListItemType.Other]: 'f-tasks-item-type-other'
};

export enum AnimalHealthLogType {
  Other = 0,
  DiedAnimal = 10,
  DiedByLocation = 20,
  Sick = 300
}

export const AnimalHealthLogTypeTranslations: Record<AnimalHealthLogType, string> = {
  [AnimalHealthLogType.Other]: 'f-animal-health-log-type-other',
  [AnimalHealthLogType.DiedAnimal]: 'f-animal-health-log-type-died',
  [AnimalHealthLogType.DiedByLocation]: 'f-animal-health-log-type-died-location',
  [AnimalHealthLogType.Sick]: 'f-animal-health-log-type-sick'
};

export enum TaskListItemStatus {
  InProgress = 10,
  Partial = 20,
  Done = 30
}

export enum TaskListStatus {
  ToDo = 10,
  InProgress = 20,
  Done = 30
}

export enum TaskPlanItemType {
  Normal = 10,
  Vaccination = 20
}

export enum TaskLibraryListType {
  TaskLibrary = 10,
  VaccinationRule = 20
}

export interface SearchCompareViewModel {
  id: string;
  name: string;
  timestamp: string;
  query: HealthSystemDomainAnimalsResultAnimalsFarmSearchRequest;
}
